import { 
  SELECT_BASE_PACK, 
  SELECT_BASE_OPTION,
  SELECT_ADD_ON,
  REMOVE_BASE_PACK,
  REMOVE_BASE_OPTION,
  REMOVE_ADD_ON
} from './pack.builder.actions.constants';

export const selectBasePack = payload => ({
  type: SELECT_BASE_PACK,
  payload
})

export const selectBaseOption = payload => ({
  type: SELECT_BASE_OPTION,
  payload
})

export const selectAddOn = payload => ({
  type: SELECT_ADD_ON,
  payload
})

export const removeBasePack = payload => ({
  type: REMOVE_BASE_PACK,
  payload
})

export const removeBaseOption = payload => ({
  type: REMOVE_BASE_OPTION,
  payload
})

export const removeAddOn = payload => ({
  type: REMOVE_ADD_ON,
  payload
})